import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { StatsDataService } from 'pf-frontend-common/src/service/stats-data/service';
import { WindowLocationService } from 'pf-frontend-common/src/service/window-location/service';

import { AgentStatsDataAdapterFactory } from 'common/data/agent/stats/data-adapter.factory';
import { AgentSerpQueryParamsAdapter } from 'common/module/agent-serp/query-params/adapter';
import { AgentSerpStoreFactory } from 'common/module/agent-serp/store.factory';
import { AgentSerpStoreParamsSearchInputAdapterFactory } from 'common/module/agent-serp/store/params/search-input-adapter.factory';
import { LoaderViewDynamicFactory } from 'common/module/loader/view-dynamic.factory';
import { PaginationComponent } from 'common/module/pagination/component';
import { PreactView } from 'common/module/preact/view';
import { AgentStoreService } from 'common/service/agent-store/service';
import { StatsService } from 'common/service/stats/service';
import { AgentList1Template } from 'desktop/module/agent/list-1/template';
import { AgentTabListViewStoreFactory } from 'desktop/module/agent/tab/list/view-store.factory';
import { AgentTabPaginationViewStoreFactory } from 'desktop/module/agent/tab/pagination/view-store.factory';
import { AgentTabView } from 'desktop/module/agent/tab/view';
import { LeadEmailFormAgentFactory } from 'desktop/module/lead/email/form/agent.factory';

export function AgentTabViewFactory(): AgentTabView {
  // TODO-FE[WEB-1602] Make AgentList re-usable like PropertyList
  const agentSerpStore = AgentSerpStoreFactory();

  return new AgentTabView(
    EventEmitterFactory(),
    new AgentSerpQueryParamsAdapter(),
    WindowLocationService(),
    new PreactView(AgentList1Template, AgentTabListViewStoreFactory(agentSerpStore)),
    new PreactView(PaginationComponent, AgentTabPaginationViewStoreFactory(agentSerpStore)),
    AgentStoreService(),
    agentSerpStore,
    LeadEmailFormAgentFactory(),
    StatsDataService(),
    StatsService(),
    AgentStatsDataAdapterFactory(),
    LoaderViewDynamicFactory(),
    AgentSerpStoreParamsSearchInputAdapterFactory()
  );
}
